import ArticleCard from './ArticleCard';

export { type ArticleCardProps } from './ArticleCard';
export default ArticleCard;
